// Labo « actions » (base visuelle 21/10) : page de prototype NON reliée à la navigation (#/lab-actions), qui compose les VRAIS
// composants d'action de la banque UBM vendored sur le même écran ACS, en trois compositions à comparer. Données fictives,
// aucun effet métier : les actions ne font qu'afficher leur propre retour.
import { CalendarX, ChefHat, ChevronRight, ShoppingBasket, SlidersHorizontal, Trash2 } from "lucide-react";
import { Button } from "@ubm/ui/components/button";
import { ActionButton } from "@ubm/ui/components/action-button";
import { SplitButton } from "@ubm/ui/components/split-button";
import { ExpandingButtonGroup } from "@ubm/ui/components/expanding-button-group";
import { HoldToConfirm } from "@ubm/ui/components/hold-to-confirm";
import { StatusBar } from "./parts";
import { ShellActions } from "./shell";
import "./lab-actions.css";

const wait = (ms: number) => new Promise<void>(r => window.setTimeout(r, ms));

function Checkin({ children }: { children: React.ReactNode }) {
  return <section className="lab-sec">
    <div className="cc-sectionhead"><h2>Check-in du jour</h2></div>
    <ul className="lab-card lab-rows"><li><span>Sommeil</span><em>7 h 30 · bonne</em></li><li><span>Stress</span><em className="todo">À renseigner</em></li></ul>
    <div className="lab-after">{children}</div>
  </section>;
}
function Meal({ children }: { children: React.ReactNode }) {
  return <section className="lab-sec">
    <div className="cc-sectionhead"><h2>Déjeuner</h2></div>
    <div className="lab-card lab-meal"><div className="lab-ph" /><div className="lab-meal-b"><small>Prévu</small><b>Bowl méditerranéen</b><span>1 portion · 20 min</span><div className="lab-meal-act">{children}</div></div></div>
  </section>;
}
function Booking({ children }: { children: React.ReactNode }) {
  return <section className="lab-sec">
    <div className="cc-sectionhead"><h2>Ma réservation</h2></div>
    <div className="lab-card lab-rows"><li><span>Cardio · 18 h 30</span><em>Réservé</em></li></div>
    <div className="lab-after">{children}</div>
  </section>;
}

export function LabActions() {
  return <div className="cc-screen cc-account lab-actions">
    <StatusBar />
    <div className="cc-scroll">
      <header className="cc-account-head"><button type="button" className="cc-icon-btn" aria-label="Retour" onClick={() => { window.location.hash = "#/accueil"; }}><ChevronRight size={18} style={{ transform: "scaleX(-1)" }} /></button><h1 className="cc-title">Labo actions</h1><ShellActions /></header>

      <div className="lab-variant" id="lab-a"><p className="lab-tag">A · Button UBM canon</p>
        <Checkin><Button variant="primary" size="lg">Faire mon check-in</Button></Checkin>
        <Meal><Button variant="secondary" size="sm"><SlidersHorizontal size={15} /> Adapter ce repas</Button></Meal>
        <Booking><Button variant="ghost" size="md">Gérer ma réservation <ChevronRight size={15} /></Button></Booking>
      </div>

      <div className="lab-variant" id="lab-b"><p className="lab-tag">B · Actions vivantes</p>
        <Checkin><ActionButton label="Faire mon check-in" pendingLabel="Envoi" successLabel="Check-in envoyé" onAction={() => wait(900)} /></Checkin>
        <Meal><SplitButton variant="secondary" size="sm" label="Adapter ce repas" icon={<SlidersHorizontal size={15} />} actions={[{ label: "Changer de recette", icon: <ChefHat size={15} /> }, { label: "Ajouter aux courses", icon: <ShoppingBasket size={15} /> }, { label: "Retirer du planning", icon: <Trash2 size={15} />, destructive: true }]} /></Meal>
        <Booking><HoldToConfirm label="Maintenir pour annuler" confirmedLabel="Réservation annulée" tone="danger" icon={<CalendarX strokeWidth={1.75} />} onConfirm={() => {}} /></Booking>
      </div>

      <div className="lab-variant" id="lab-c"><p className="lab-tag">C · Barre d'actions dépliante</p>
        <Checkin><Button variant="primary" size="lg">Faire mon check-in</Button></Checkin>
        <Meal><ExpandingButtonGroup label="Actions du repas" size="sm" items={[
          { id: "adapter", label: "Adapter", icon: <SlidersHorizontal /> },
          { id: "recette", label: "Recette", icon: <ChefHat /> },
          { id: "courses", label: "Aux courses", icon: <ShoppingBasket />, doneLabel: "Ajouté" },
          { id: "retirer", label: "Retirer", icon: <Trash2 />, tone: "danger", doneLabel: "Retiré" },
        ]} /></Meal>
        <Booking><ExpandingButtonGroup label="Actions de la réservation" size="md" items={[
          { id: "voir", label: "Voir la séance", icon: <ChevronRight /> },
          { id: "annuler", label: "Annuler", icon: <CalendarX />, tone: "danger", doneLabel: "Annulée" },
        ]} /></Booking>
      </div>
    </div>
  </div>;
}
